import { IActionTypeGroups, IAvailabel, IReactionParameter, IActionTypeItem } from '../types';

export const generateRandomKey = () => Math.random().toString(36).substr(2, 11);

export const getIsWidth100 = (styleType: IReactionParameter['style']) => {
  return Boolean(styleType === 'wrap');
};

export const getIsFlex = (suffix: React.ReactNode, prefix: React.ReactNode) => {
  return Boolean(suffix || prefix);
};

export const conditionType = {
  none: 'RealWorld.Conditions.None'
};

export const getBaseCommandType = ({ availabelType }: IAvailabel) => {
  if (availabelType === 'quest') {
    return [
      {
        key: generateRandomKey(),
        type: 'RealWorld.Commands.DisplayHtml',
        parameters: {
          content: '<p>사용자에게 표시 될 사항을 적어주세요</p>'
        }
      },
      {
        key: generateRandomKey(),
        type: 'RealWorld.Commands.GoBack',
        parameters: {}
      }
    ];
  }
  if (availabelType === 'chatbot') {
    return [
      {
        key: generateRandomKey(),
        type: 'RealWorld.Commands.SendChatbotMessage',
        parameters: {}
      }
    ];
  }
  return [
    {
      key: generateRandomKey(),
      type: 'RealWorld.Commands.GoBack',
      parameters: {}
    }
  ];
};

export const ACTION_TYPE_METADATA: Record<string, Omit<IActionTypeItem, 'type'>> = {
  'RealWorld.ActionTypes.Dummy': {
    label: '액션 없음',
    icon: 'times_regular'
  },
  'RealWorld.ActionTypes.Text': {
    label: '텍스트 입력',
    icon: 'interactive_icons_forms'
  },
  'RealWorld.ActionTypes.DirectionSequence': {
    label: '방향 입력',
    icon: 'interactive_icons_direction_arrows'
  },
  'RealWorld.ActionTypes.Password': {
    label: '4자리 비밀번호 입력',
    icon: 'interactive_icons_password'
  },
  'RealWorld.ActionTypes.Button': {
    label: '버튼 클릭',
    icon: 'interactive_icons_button_click'
  },
  'RealWorld.ActionTypes.WebView': {
    label: '웹뷰 페이지 활용',
    icon: 'interactive_icons_web_view'
  },
  'RealWorld.ActionTypes.AR': {
    label: '[카메라] AR 이미지 인식',
    icon: 'interactive_icons_photo_scan'
  },
  'RealWorld.ActionTypes.QR': {
    label: '[카메라] QR 코드 인식',
    icon: 'interactive_icons_qrcode'
  },
  'RealWorld.ActionTypes.FrameShot': {
    label: '[카메라] 프레임 사진 촬영',
    icon: 'interactive_icons_photo_frame'
  },
  'RealWorld.ActionTypes.Nfc': {
    label: '[NFC] NFC 태그 인식',
    icon: 'interactive_icons_nfc'
  },
  'RealWorld.ActionTypes.GpsRadar': {
    label: '[GPS] 특정 장소로 이동',
    icon: 'interactive_icons_gps'
  },
  'RealWorld.ActionTypes.ColorFilter': {
    label: '[카메라] 컬러 필터 렌즈',
    icon: 'interactive_icons_color_filter'
  },
  'RealWorld.ActionTypes.CameraOverlap': {
    label: '[카메라] 오버랩',
    icon: 'interactive_icons_overlap'
  },
  'RealWorld.ActionTypes.FrameShotV2': {
    label: '다기능 프레임 사진 촬영',
    icon: 'interactive_icons_photo_frame'
  },
  'RealWorld.ActionTypes.GpsMap': {
    label: '[GPS] 특정 여러 장소로 이동',
    icon: 'interactive_icons_gps'
  },
  'RealWorld.ActionTypes.ImageDetection': {
    label: '[카메라] 이미지 비교',
    icon: 'interactive_icons_photo_scan'
  },
  'RealWorld.ActionTypes.ImageDetection.Scratch': {
    label: '[카메라] 스크래치 이미지 비교',
    icon: 'interactive_icons_photo_scan'
  }
};

const createItem = (type: string): IActionTypeItem => ({
  type,
  ...ACTION_TYPE_METADATA[type]
});

export const actionTypeGroups: IActionTypeGroups = {
  General: [
    createItem('RealWorld.ActionTypes.Dummy'),
    createItem('RealWorld.ActionTypes.Text'),
    createItem('RealWorld.ActionTypes.DirectionSequence'),
    createItem('RealWorld.ActionTypes.Password'),
    createItem('RealWorld.ActionTypes.Button'),
    createItem('RealWorld.ActionTypes.WebView')
  ],
  Advanced: [
    createItem('RealWorld.ActionTypes.AR'),
    createItem('RealWorld.ActionTypes.QR'),
    createItem('RealWorld.ActionTypes.FrameShot'),
    createItem('RealWorld.ActionTypes.Nfc'),
    createItem('RealWorld.ActionTypes.GpsRadar'),
    createItem('RealWorld.ActionTypes.ColorFilter'),
    createItem('RealWorld.ActionTypes.CameraOverlap')
  ],
  Additional: [
    createItem('RealWorld.ActionTypes.FrameShotV2'),
    createItem('RealWorld.ActionTypes.GpsMap'),
    createItem('RealWorld.ActionTypes.ImageDetection'),
    createItem('RealWorld.ActionTypes.ImageDetection.Scratch')
  ]
};
